/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-inner-declarations */

//import { data } from 'jquery';
import { Collapse } from 'bootstrap';
export default {
  init() {
    // JavaScript to be fired on all pages


    // change collapse showrooms button
    const allShowrooms = document.getElementById('collapseShowrooms');
    const showroomsButton = document.getElementById('collapseShowroomsButton');
    if(allShowrooms){
      allShowrooms.addEventListener('show.bs.collapse', () => {
        showroomsButton.textContent = 'Hide all showrooms';
        showroomsButton.classList.add('minus');
      })
      allShowrooms.addEventListener('hide.bs.collapse', () => {
        showroomsButton.textContent = 'Show all showrooms';
        showroomsButton.classList.remove('minus');
      })
    }
    

    // change kitchen specifications accordion icon to minus when shown, back to plus on hide   
    const kitchenAccordionIcon = document.querySelectorAll('.accordion__icon');
    const kitchenCollapsible = document.querySelectorAll('.kitchen-collapsible');
    if(kitchenCollapsible){
      for (let i = 0; i < kitchenCollapsible.length; i++) {
        kitchenCollapsible[i].addEventListener('show.bs.collapse', () => {
          kitchenAccordionIcon[i].classList.remove('fa-plus-large');
          kitchenAccordionIcon[i].classList.add('fa-minus');
        })
      }

      for (let i = 0; i < kitchenCollapsible.length; i++) {
        kitchenCollapsible[i].addEventListener('hide.bs.collapse', () => {
          kitchenAccordionIcon[i].classList.remove('fa-minus');
          kitchenAccordionIcon[i].classList.add('fa-plus-large');
        })
      }
    }

    
    

    // JS scroll notch to go to next section on content page hero banner
    const scrollNotch = document.querySelector('.content-page-hero__scroll-notch');
    const contentPageHero = document.querySelector('.content-page-hero');
    if(scrollNotch){
      scrollNotch.addEventListener('click', () => {
        let scrollNotchNext = contentPageHero.nextElementSibling;
        // changed to this because it could offset fixed header
        window.scroll({
          top: scrollNotchNext.offsetTop - 100,
          left: 0,
          behavior: 'smooth',
        });
      })
    }


    // JS scroll notch to go to next section on book a design appointment page (showroom finder block)
    const scrollNotchShowroomFinder = document.querySelector('.showroom-finder__scroll-notch');
    const showroomFinder = document.querySelector('.showroom-finder');
    if(scrollNotchShowroomFinder){
      scrollNotchShowroomFinder.addEventListener('click', () => {
        let scrollNotchNextShowroom = showroomFinder.nextElementSibling;
        // changed to this because it could offset fixed header  
        window.scroll({
          top: scrollNotchNextShowroom.offsetTop,
          left: 0,
          behavior: 'smooth',
        });
      })
    }


    //JS scroll notch to go to next section for Kitchen Planner
    const scrollNotchFull = document.querySelector('.content-page-hero-full__wrapper__scroll-notch');
    const contentPageHeroFull = document.querySelector('.content-page-hero-full');
    if(scrollNotchFull){
      scrollNotchFull.addEventListener('click', () => {
        let scrollNotchFullNext = contentPageHeroFull.nextElementSibling;

        // changed to this because it could offset fixed header
        window.scroll({
          top: scrollNotchFullNext.offsetTop - 100,
          left: 0,
          behavior: 'smooth',
        });
      });
    }




  
    //=========================================
    //  NAVS
    //
    //=========================================
    // JS for mobile menu open
    const menuOpenButtons = document.querySelectorAll('.primary-nav__mobile-menu-toggle');
    const menuCloseButton = document.querySelector('.mobile-nav__close-menu');
    const mobileMenu = document.querySelector('.mobile-nav');

    const openMobileMenu = () => {
      mobileMenu.classList.add('menu-open');
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    }
    const closeMobileMenu = () => {
      mobileMenu.classList.remove('menu-open');
      document.body.style.overflowY = 'auto';
      document.documentElement.style.overflowY = 'auto';
    }

    // check menu open button on both standard and fixed headers
    for (let i = 0; i < menuOpenButtons.length; i++) {
      menuOpenButtons[i].addEventListener('click', () => {
        if(mobileMenu.classList.contains('menu-open')){
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    }

    menuCloseButton.addEventListener('click', () => {
      if(mobileMenu.classList.contains('menu-open')){
        closeMobileMenu();
      }
    })

    // Close slide mobile menu if clicking outside of it 
    document.addEventListener('mouseup', (event) => {
      if (!mobileMenu.contains(event.target)){
        closeAllMobileSubMenus(); // close all sub-menus first
        closeMobileMenu(); 
      }
    })



    /*********************** MOBILE SUB-MENUS ********************/
    const mobileSubMenuButtons = document.querySelectorAll('.mobile-nav__sub-menu-buttons');
    const mobileSubMenus = document.querySelectorAll('.mobile-nav__sub-menu');
    const mobileSubMenuBackButtons = document.querySelectorAll('.mobile-nav__sub-menu__back');

    const openMobileSubMenu = (mobileDataMenu) => {
      // use passed target to get correct sub-menu
      let targetMobileSubMenu = document.getElementById(`mobile-sub-menu-${mobileDataMenu}`);
      // open it
      targetMobileSubMenu.classList.add('mobile-sub-menu-active');
    }

    const closeAllMobileSubMenus = () => {
      for(let i = 0; i < mobileSubMenus.length; i++){
        mobileSubMenus[i].classList.remove('mobile-sub-menu-active');
      }
    }

    // add event listener for all mobile sub-menu buttons
    for (let i = 0; i < mobileSubMenuButtons.length; i++){
      mobileSubMenuButtons[i].addEventListener('click', (event) => {
        // get the targeted menu from the button
        let mobileDataMenu = event.target.dataset.menu;
        // pass targeted menu to our open mobile sub menu function
        openMobileSubMenu(mobileDataMenu);
      })
    }

    // if any back button is clicked, close all sub menus
    for (let i = 0; i < mobileSubMenuBackButtons.length; i++){
      mobileSubMenuBackButtons[i].addEventListener('click', () => {
        closeAllMobileSubMenus();
      })
    }

    /************************************************************/




    /************************* JS for sub-menu *************************/
    const subMenuButtons = document.querySelectorAll('.has-sub-menu');
    const subMenus = document.querySelectorAll('.sub-menu-wrapper');
    const subMenuCloseButtons = document.querySelectorAll('.sub-menu-wrapper__close');
    
    for(let i = 0; i<subMenuButtons.length; i++){
      subMenuButtons[i].addEventListener('click', (e) => {
        let targetSubMenu = document.getElementById('sub-menu-' + e.target.dataset.menu);
        if(targetSubMenu.classList.contains('sub-menu-wrapper-open')){                                    // CLICKED MENU ALREADY OPEN
          tkdCloseSubNav(targetSubMenu);
        }else{                                                                                            // CLICKED MENU NOT YET OPEN
          tkdCloseSubNav();
          let btnOffsetLeft = e.target.offsetLeft;
          let btnWidth = e.target.offsetWidth / 2;
          let diamond = targetSubMenu.querySelector('.diamond');
          diamond.style.left = `${(btnOffsetLeft - e.target.parentNode.offsetLeft) + btnWidth}px`;
          targetSubMenu.classList.add('sub-menu-wrapper-open');
          e.target.classList.add('sub-menu-wrapper-active');
        }
      });
    }

    for(let i = 0; i<subMenuCloseButtons.length; i++){                                                    // ANY TIME A NAV'S X IS CLICKED, CLOSE EM ALL!
      subMenuCloseButtons[i].addEventListener('click', () => { tkdCloseSubNav(); });
    }

    function tkdCloseSubNav(item = null){                                                                 // HELPER FUNCTION TO CLOSE SUB NAVS
      if(!item){ subMenus.forEach(menu => { menu.classList.remove('sub-menu-wrapper-open'); }); }
      else{ item.classList.remove('sub-menu-wrapper-open');}
      subMenuButtons.forEach(btn => { btn.classList.remove('sub-menu-wrapper-active'); });
    }

    document.addEventListener('click', (e) => {    
      if(e.target.offsetParent){
        if(!e.target.offsetParent.classList.contains('sub-menu-wrapper') && !e.target.classList.contains('has-sub-menu')){
          tkdCloseSubNav();
        }
      }                                                       // IF CLICKING ON SOMETHING OTHER THAN THE NAV, CLOSE ANY OPEN NAVS
    });

    

    /*************************************************************************************/


    // add class to rotate cross in footer when mobile accordion is triggered
    const footerCollapsibles = document.querySelectorAll('.footer-mobile-collapsible');
    const footerCollapsibleLinks = document.querySelectorAll('.mobile-collapsible-link');

    footerCollapsibles.forEach((collapsible, index) => {
      collapsible.addEventListener('show.bs.collapse', () => {
        footerCollapsibleLinks[index].classList.add('active-rotate-cross');
      })
      collapsible.addEventListener('hide.bs.collapse', () => {
        footerCollapsibleLinks[index].classList.remove('active-rotate-cross');
      })
    })



    // STICKY HEADER - FOR TWO SEPARATE HEADERS
    
    const stickyHeader = document.querySelector('.header--sticky');
    let fixedOffset = 500;
    if(stickyHeader){
      const deviceWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
      if(deviceWidth < 768){
        fixedOffset = 250;
      } 
      window.addEventListener('scroll', () => {
        let scrollY = window.pageYOffset || window.scrollTop || 0;
        if(scrollY > fixedOffset){
          stickyHeader.classList.add('sticky-appear');
        } else {
          stickyHeader.classList.remove('sticky-appear');
        }
      })
      window.addEventListener('load', () => {
        let scrollY = window.pageYOffset || window.scrollTop || 0;
        if(scrollY > fixedOffset){
          stickyHeader.classList.add('sticky-appear');
        } else {
          stickyHeader.classList.remove('sticky-appear');
        }
      })
    }




    //====================================================
    //  General Enquiries (Aftercare columns block) 
    //  Select dropdown (displays selected showroom contact card)
    //  Added: 8/8/22
    //====================================================
    const geBranchesSelect = document.getElementById('ge-branches-select');
    if(geBranchesSelect){
      const allCards = document.querySelectorAll('.ge-selected__contact-card');
      geBranchesSelect.addEventListener('change', (e) => {
        e.preventDefault();
        for( let i = 0; i < allCards.length; i++){
          allCards[i].style.display = 'none';
        }
        const value = geBranchesSelect.value;
        let selectedCard = document.getElementById(value);
        selectedCard.style.display = 'block';
      })
    }


    //====================================================
    //  General Enquiries (Aftercare columns block) 
    //  Add active state red border when uncollapsed
    //  Added: 9/8/22
    //====================================================
    const enquiryClickables = document.querySelectorAll('.enquiry-clickable');
    const enquiryCollapsibles = document.querySelectorAll('.enquiry-collapsible');
    for(let i = 0; i < enquiryCollapsibles.length; i++){
      // As soon as starts to show, add red border to button
      enquiryCollapsibles[i].addEventListener('show.bs.collapse', (e) => {
        addBorder(i);
      })
      // Once fully shown, scroll to uncollapsed
      enquiryCollapsibles[i].addEventListener('shown.bs.collapse', (e) => {
        addBorder(i);
        window.scroll({
          top: e.target.offsetTop,
          left: 0,
          behavior: 'smooth',
        });
      })
      // As soon as starts to hide, remove border
      enquiryCollapsibles[i].addEventListener('hide.bs.collapse', (e) => {
        removeBorder(i);
      })
    }
    const addBorder = (i) => {
      enquiryClickables[i].classList.add('column-selected');
    }
    const removeBorder = (i) => {
      enquiryClickables[i].classList.remove('column-selected');
    }


    //====================================================
    //  Brochure Download (Aftercare columns block) 
    //  Scroll to next form on page if download button clicked
    //  Added: 23/8/22
    //====================================================

    const brochureDownloadButtons = document.querySelectorAll('.brochure--scroll-to-form');

    if(brochureDownloadButtons.length != 0){
      const brochureForm = document.querySelector('.tkd-form-block');
      // console.log(brochureForm.offsetTop);
      for(let i = 0; i < brochureDownloadButtons.length; i++){
        brochureDownloadButtons[i].addEventListener('click', (e) => {
          window.scroll({
            top: brochureForm.offsetTop,
            left: 0,
            behavior: 'smooth',
          });
        })
      }
    }
    


    

    //====================================================
    //  Book an appointment / branch finder
    //  Added: 26/7/22
    //====================================================
    if(document.getElementById('postcode-form')){
      var markers = [];
      var map;
      window.initMap = function() {
        var $el = $('.map');
        var jsmarkers = showrooms;                                                          // Find marker elements within map.

        // Create map.
        var mapArgs = {
          zoom        : $el.data('zoom') || 16,
          mapTypeId   : google.maps.MapTypeId.ROADMAP,
          disableDefaultUI: true, // disable the default User Interface
          zoomControl: true, // add back fullscreen, streetview, zoom
          streetViewControl: true,
          fullscreenControl: false,
          styles       : [
            {
              'featureType': 'water',
              'elementType': 'geometry.fill',
              'stylers': [ { 'color': '#d3d3d3' } ],
            },
            {
              'featureType': 'transit',
              'stylers': [
                { 'color': '#808080' },
                { 'visibility': 'off' },
              ],
            },
            {
              'featureType': 'road.highway',
              'elementType': 'geometry.stroke',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#b3b3b3' },
              ],
            },
            {
              'featureType': 'road.highway',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#ffffff' } ], 
            },
            {
              'featureType': 'road.local',
              'elementType': 'geometry.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#ffffff' },
                { 'weight': 1.8 },
              ],
            },
            {
              'featureType': 'road.local',
              'elementType': 'geometry.stroke',
              'stylers': [{ 'color': '#d7d7d7' }],
            },
            {
              'featureType': 'poi',
              'elementType': 'geometry.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#ebebeb' },
              ],
            },
            {
              'featureType': 'administrative',
              'elementType': 'geometry',
              'stylers': [{ 'color': '#a7a7a7' }],
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#ffffff' }],
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#ffffff' }],
            },
            {
              'featureType': 'landscape',
              'elementType': 'geometry.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#efefef' },
              ],
            },
            {
              'featureType': 'road',
              'elementType': 'labels.text.fill',
              'stylers': [{ 'color': '#696969' }],
            },
            {
              'featureType': 'administrative',
              'elementType': 'labels.text.fill',
              'stylers': [
                { 'visibility': 'on' },
                { 'color': '#737373' },
              ],
            },
            {
              'featureType': 'poi',
              'elementType': 'labels.icon',
              'stylers': [{ 'visibility': 'off' } ],
            },
            {
              'featureType': 'poi',
              'elementType': 'labels',
              'stylers': [{ 'visibility': 'off' }],
            },
            {
              'featureType': 'road.arterial',
              'elementType': 'geometry.stroke',
              'stylers': [{ 'color': '#d6d6d6' }],
            },
            {
              'featureType': 'road',
              'elementType': 'labels.icon',
              'stylers': [{ 'visibility': 'off' }],
            },
            {},
            {
              'featureType': 'poi',
              'elementType': 'geometry.fill',
              'stylers': [{ 'color': '#dadada' }],
            },
          ],
        };

        var map = new google.maps.Map( $el[0], mapArgs );
        // Add markers.
        map.markers = [];
        for(let i = 0; i < jsmarkers.length; i++){
          initMarker(jsmarkers[i], map);
        }

        centerMap( map );// Center map based on markers.
                    
        var form = document.getElementById('postcode-form');
        form.addEventListener('submit', function(e){
          e.preventDefault();
          var postcode = document.getElementById('postcode-field').value;
          handlePostcodeSearch(postcode, map);
        });

        return map;                                                                                               // Return map instance
      }


      // Pop the markers on the map
      function initMarker( mark, map ) {   

        if(mark['lat'] && mark['lng']){                                                                           // Only create marker if lat and lng present
          var marker = new google.maps.Marker({                                                                   // Create marker instance
            position : {lat: parseFloat( mark['lat'] ), lng: parseFloat( mark['lng'] )},                          // Create lat/lng object based on branches
            map: map,                                                                                             // Required refrence to the map
            title: mark['branch'],
            animation: google.maps.Animation.DROP,
            slug: mark['slug'],                                                                                   // Used when clicking a marker to update branch details
            address: mark['address'],
            permalink: mark['permalink'],
            icon: {                                                                                               // Custom SVG icon
              path: 'M25.106,3A17.593,17.593,0,0,0,7.5,20.606c0,13.2,17.606,32.7,17.606,32.7s17.606-19.492,17.606-32.7A17.593,17.593,0,0,0,25.106,3Z',
              fillColor: '#da291c',
              fillOpacity: 1,
              strokeWeight: 0,
              rotation: 0,
              scale: 0.75,
              anchor: new google.maps.Point(0, 50),
            },
          });

          markers.push(marker);                                                                                   // Push marker to markers array for later use
          map.markers.push( marker );                                                                             // Append to reference for later use.

          google.maps.event.addListener(marker, 'click', function() {                                             // Create an event listener to update branch details on marker click
            let fixedBranchInfo = document.querySelector('#fixed-branch-info');                                   // Grab branch detail container
            fixedBranchInfo.querySelector('.showroom-card__title').innerText = marker.title;                      // Update content
            fixedBranchInfo.querySelector('.showroom-card__address').innerText = marker.address;
            fixedBranchInfo.querySelector('.showroom-card__view-btn').href = marker.permalink;
            fixedBranchInfo.querySelector('.showroom-card__book-btn').setAttribute('branch', marker.slug);
            if(fixedBranchInfo.classList.contains('d-none')){ fixedBranchInfo.classList.remove('d-none'); }       // This should always be visible by this point, but just in case!
          });
        }                                                                                                         // END if lat & lng exists
      }

      function centerMap( map ) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
          bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
          map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
          map.fitBounds( bounds );
        }
      }

      function handlePostcodeSearch(postcode, map){
        var lat = '';
        var lng = '';
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode( { 
          'region' : 'gb', // Including 'gb' is necessary to avoid coords being returned for search "renfrew" which breaks distance measuring in Distance Matrix API
          'address': postcode,
        },
        function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            lat = results[0].geometry.location.lat();
            lng = results[0].geometry.location.lng();
            //Make the marker
            var youAreHere = new google.maps.Marker({
              position:new google.maps.LatLng(lat,lng),
              map: map,
            });

            find_closest_marker(youAreHere, map);
          }else {
            // TODO: replace with error message in #showroom-finder-message
            console.error('Geocode was not successful for the following reason: ' + status);
          }
        });
      }

      function find_closest_marker(userLocation, map) {
        var distances = [];
        var closest = -1;
        // console.log(map)
        for (let i = 0; i < map.markers.length; i++) {
          var d =  google.maps.geometry.spherical.computeDistanceBetween(map.markers[i].position, userLocation.position);
          distances[i] = d;
          if (closest == -1 || d < distances[closest]) {
            closest = i;
          }
        }

        if(closest > -1){
          // console.log('Closest marker is: ' + map.markers[closest].title);
          calculateDistances(userLocation, map.markers, map);
        }
      }

      function calculateDistances(pt, closest, map) {
        var service = new google.maps.DistanceMatrixService();
        var request = {
          origins: [pt.position],
          destinations: [],
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
        };
        for (let i = 0; i < closest.length; i++) {
          request.destinations.push(closest[i].getPosition());
        }

        service.getDistanceMatrix(request, function(response, status) {
          // console.log(response)
          if (status != google.maps.DistanceMatrixStatus.OK) {
            // TODO: replace log with error message in div #showroom-finder-message
            // console.log('Error was: ' + status);
          } else {
            var origins = response.originAddresses;
            var destinations = response.destinationAddresses;
            var results = response.rows[0].elements;

            
            // NOTE: super weird bug where wptexturize() has a regex which doesn't work correctly if
            // && and < are used - but swapping to > resolves the issue... for now!
            // https://core.trac.wordpress.org/ticket/45387
            for (var i = 0; i < closest.length; i++) {                                        // save title and address in record for sorting
              results[i].title = closest[i].title;
              results[i].address = destinations[i];
              results[i].idx_closestMark = i;
              results[i].position = closest[i].position;
              results[i].permalink = closest[i].permalink;
              results[i].slug = closest[i].slug;                                             // Used to inset distances/times into the form array if present
            }

            results.sort(sortByDistDM);                                                       // Sort the results by distance

            if(results){                                                                      // Ensure results are found before working with div
              const collapseableArea = document.querySelector('#showroom-finder-collapse');   // Define collapseable div
              let fixedBranchInfo = document.querySelector('#fixed-branch-info');             // Define the branch info div
              if(collapseableArea && !collapseableArea.classList.contains('show')){           // if div is found and not already open
                let collapseable = new Collapse(collapseableArea, { toggle: true });          // Define div as collapseable
                collapseable.show();                                                          // Open the accordion
                google.maps.event.trigger(map, 'resize');                                     // Trigger resize of maps (due to map being hidden on load)
              }

              
              map.setZoom( 11 )                                                               // Set zoom level of map
              map.panTo(results[0].position);                                                 // Slide to nearest branch (wont slide if too far away)
              pt.setMap(null);                                                                // Hide the new map marker based on user input


              //Update info
              if(showrooms && showrooms.length > 0){
                for(let i = 0; i < showrooms.length; i++){
                  for(let j = 0; j < results.length; j++){
                    if(showrooms[i].slug === results[j].slug){
                      showrooms[i].distance = results[j].distance.text;
                      showrooms[i].duration = results[j].duration.text;
                      results[j].permalink = showrooms[i].permalink;
                      results[j].address = showrooms[i].address;
                      results[j].opening_hours = showrooms[i].opening_hours;
                    }
                  }
                }
              }
       
              

              const closestShowroomWrap = document.querySelector('#showroom-closest-list');   //
              if(closestShowroomWrap){
                closestShowroomWrap.innerHTML = '';                                           // Ensure container is always emptied before a new search
                  for(let i = 0; i < 3; i++){                         
                    let showroom = populateNearestShowroom(results[i], i);
                    closestShowroomWrap.append(showroom);
                  }


                  // if nearest branches are found, add event listener for a click on the book showroom button
                  // on click, change the selected form select menu
                  // also scroll down to form
                  //
                  let nearestBranches = document.querySelectorAll('.nearest-showroom-book-btn');
                  if(nearestBranches){
                    nearestBranches.forEach((branch) => {
                      branch.addEventListener('click', (e) => {
                        e.preventDefault();
                        let clickedBranch = e.target.dataset.branch;
                        selectBranchFromForm(clickedBranch)
                     });                        
                    })
                  }

              }

              //Update text based on nearest showroom
              fixedBranchInfo.querySelector('.showroom-card__title').innerText = results[0].title;
              fixedBranchInfo.querySelector('.showroom-card__address').innerText = results[0].address;
              fixedBranchInfo.querySelector('.showroom-card__view-btn').href = results[0].permalink;
              fixedBranchInfo.querySelector('.showroom-card__book-btn').setAttribute('branch', results[0].slug)
              if(fixedBranchInfo.classList.contains('d-none')){ fixedBranchInfo.classList.remove('d-none'); }

              
            }
            
            
          }
        });
      }
      
      function populateNearestShowroom(showroom, index){
        if(!showroom){ return false; }
        let slug = (showroom.slug) ? showroom.slug : '#';
        let title = (showroom.title) ? showroom.title : 'The Kitchen Depot';
        let distance = (showroom.distance.value) ? showroom.distance.value : false;
        let duration = (showroom.duration.text) ? showroom.duration.text : false;
        let opening_hours = (showroom.opening_hours) ? showroom.opening_hours : false;
        let distanceMsg = (distance && duration) ? Math.round((distance / 1000) * 0.621371) + ' miles away ' + '(' + duration +')' : '';
        let permalink = (showroom.permalink) ? showroom.permalink : '';
        let address = (showroom.address) ? showroom.address.replace(/(\r\n|\n\r)/gm, '<br/>') : false;
        let el = document.createElement('div');
        el.classList.add('nearest-showrooms', 'col', 'mb-4', 'mb-sm-5', 'mb-lg-0');
        let pinSVG = '';
        if(index == 0){
          pinSVG = '<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" width="24.19" height="34.29" viewBox="0 0 24.19 34.29"><g id="Layer_1-2"><g><path d="M11.22,14.33h2.43c-.5-1.47-.9-2.66-1.2-3.55-.3,.84-.71,2.03-1.23,3.55Z" fill="none"/><path d="M12.11,1.5l-.02-.75v.75h0C6.25,1.5,1.5,6.25,1.5,12.08c0,7.07,8.34,17.31,10.6,19.95,2.26-2.64,10.6-12.87,10.6-19.93,0-5.84-4.74-10.59-10.58-10.6Zm2.8,16.67c-.18-.53-.41-1.24-.67-2.11h-3.63c-.15,.48-.38,1.18-.69,2.11h-2.1l3.73-10.13h1.76l3.73,10.13h-2.13Z" fill="none"/><path d="M11.56,8.04l-3.73,10.13h2.1c.31-.93,.54-1.63,.69-2.11h3.63c.27,.88,.49,1.58,.67,2.11h2.13l-3.73-10.13h-1.76Zm-.34,6.29c.52-1.53,.93-2.71,1.23-3.55,.3,.9,.7,2.08,1.2,3.55h-2.43Z" fill="#2b2b2b"/><path d="M12.11,0h-.02C5.43,0,0,5.42,0,12.1c0,8.7,11.07,21.06,11.54,21.58l.56,.62,.56-.62c.47-.52,11.54-12.88,11.54-21.58C24.2,5.43,18.78,0,12.11,0Zm-.02,32.03C9.84,29.39,1.5,19.16,1.5,12.08c0-5.84,4.75-10.58,10.59-10.58h0V.75s.02,.75,.02,.75c5.84,0,10.59,4.76,10.58,10.6,0,7.06-8.34,17.29-10.6,19.93Z" fill="#da291c"/></g></g></svg>'
        } else if(index == 1) {
          pinSVG = '<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" width="24.2" height="34.29" viewBox="0 0 24.2 34.29"><g id="Layer_1-2"><g><path d="M12.21,13.66h-1.09v2.93c.27,.09,.65,.13,1.14,.13,1.03,0,1.55-.45,1.55-1.36,0-1.13-.53-1.7-1.6-1.7Z" fill="none"/><path d="M13.65,10.84c0-.84-.54-1.27-1.63-1.3h-.05c-.27,0-.55,.03-.85,.1v2.34h1.18c.9,0,1.34-.38,1.34-1.14Z" fill="none"/><path d="M12.11,1.5l-.02-.75v.75h0C6.25,1.5,1.5,6.25,1.5,12.08c0,7.08,8.34,17.31,10.6,19.95,2.26-2.64,10.6-12.87,10.6-19.93,0-5.84-4.74-10.59-10.58-10.6Zm2.61,16.18c-.74,.46-1.72,.69-2.94,.69-1.07,0-1.98-.07-2.75-.21V8.06c.81-.14,1.79-.21,2.94-.21,1.33,0,2.33,.32,2.98,.94,.51,.5,.77,1.16,.77,1.98,0,.5-.21,.96-.62,1.37-.42,.41-.88,.62-1.39,.62v.02c.7,.07,1.26,.35,1.67,.82,.41,.47,.62,1.06,.62,1.78,0,1-.42,1.77-1.26,2.3Z" fill="none"/><path d="M13.7,12.78v-.02c.51,0,.98-.21,1.39-.62,.42-.41,.62-.87,.62-1.37,0-.82-.26-1.48-.77-1.98-.65-.63-1.64-.94-2.98-.94-1.15,0-2.13,.07-2.94,.21v10.1c.77,.14,1.69,.21,2.75,.21,1.23,0,2.21-.23,2.94-.69,.84-.53,1.26-1.3,1.26-2.3,0-.71-.21-1.31-.62-1.78-.41-.47-.97-.74-1.67-.82Zm-2.58-3.14c.3-.06,.58-.1,.85-.1h.05c1.09,.02,1.63,.45,1.63,1.3,0,.76-.45,1.14-1.34,1.14h-1.18v-2.34Zm1.14,7.07c-.49,0-.87-.04-1.14-.13v-2.93h1.09c1.07,0,1.6,.57,1.6,1.7,0,.91-.52,1.36-1.55,1.36Z" fill="#2b2b2b"/><path d="M12.11,0h-.02C5.43,0,0,5.42,0,12.1c0,8.7,11.07,21.06,11.54,21.58l.56,.62,.56-.62c.47-.52,11.54-12.88,11.54-21.58C24.2,5.43,18.78,0,12.11,0Zm-.02,32.03C9.84,29.39,1.5,19.16,1.5,12.08c0-5.84,4.75-10.58,10.59-10.58h0V.75s.02,.75,.02,.75c5.84,0,10.59,4.76,10.58,10.6,0,7.06-8.34,17.29-10.6,19.93Z" fill="#da291c"/></g></g></svg>'
        } else if(index == 2) {
          pinSVG = '<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" width="24.2" height="34.29" viewBox="0 0 24.2 34.29"><g id="Layer_1-2"><g><path d="M12.11,1.5l-.02-.75v.75h0C6.25,1.5,1.5,6.25,1.5,12.08c0,7.07,8.34,17.31,10.6,19.95,2.26-2.64,10.6-12.87,10.6-19.93,0-5.84-4.74-10.59-10.58-10.6Zm1.03,16.86c-1.72,0-3-.64-3.84-1.92-.61-.92-.91-2-.91-3.23,0-1.61,.42-2.91,1.25-3.89,.82-.98,1.96-1.47,3.42-1.47,1.02,0,2.05,.43,3.07,1.3l-.82,1.33c-.77-.55-1.47-.83-2.1-.83-.88,0-1.55,.37-2.03,1.1-.42,.63-.62,1.45-.62,2.46,0,.9,.25,1.66,.74,2.3,.52,.67,1.22,1.01,2.1,1.01,.58,0,1.26-.25,2.05-.75l.82,1.26c-.89,.88-1.93,1.33-3.12,1.33Z" fill="none"/><path d="M13.4,16.52c-.87,0-1.57-.34-2.1-1.01-.49-.64-.74-1.41-.74-2.3,0-1.01,.21-1.83,.62-2.46,.48-.74,1.16-1.1,2.03-1.1,.63,0,1.33,.28,2.1,.83l.82-1.33c-1.02-.86-2.05-1.3-3.07-1.3-1.46,0-2.6,.49-3.42,1.47-.83,.98-1.25,2.28-1.25,3.89,0,1.24,.3,2.31,.91,3.23,.84,1.28,2.12,1.92,3.84,1.92,1.19,0,2.23-.44,3.12-1.33l-.82-1.26c-.79,.5-1.47,.75-2.05,.75Z" fill="#2b2b2b"/><path d="M12.11,0h-.02C8.86,0,5.83,1.26,3.55,3.54,1.26,5.82,0,8.85,0,12.1c0,8.7,11.07,21.06,11.54,21.58l.56,.62,.56-.62c.47-.52,11.54-12.88,11.54-21.58C24.2,5.43,18.78,0,12.11,0Zm-.02,32.03C9.84,29.39,1.5,19.16,1.5,12.08c0-5.84,4.75-10.58,10.59-10.58h0V.75l.02,.75c5.84,0,10.59,4.76,10.58,10.6,0,7.06-8.34,17.29-10.6,19.93Z" fill="#da291c"/></g></g></svg>';
        }

        // const days = {
        //   'Mon' : 'Monday',
        //   'Tue' : 'Tuesday',
        //   'Wed' : 'Wednesday',
        //   'Thur' : 'Thursday',
        //   'Fri' : 'Friday',
        //   'Sat' : 'Saturday',
        //   'Sun' : 'Sunday',
        // }
        // let today = new Date();
        // let todayName = today.toDateString().split(' ')[0];
        
        // Object.keys(days).forEach((day, index) => {
        //   if(day == todayName){
        //     console.log(day)
        //   }
        // })

        el.innerHTML = `
          <div class="">
            <div class="showroom-card d-flex flex-column justify-content-between">
              <div>
                <div class="showroom-card__header row align-items-center">
                  <div class="col-auto">
                    <div class="showroom-card__icon">
                      ${pinSVG}
                    </div>
                  </div>
                  <div class="col">
                    <h5>${title}</h5>
                    <p class="showroom-card__miles">${distanceMsg}</p>
                  </div>
                </div>
                <p class="showroom-card__open-until"></p>
                <p class="showroom-card__address">${address}</p>
              </div>

              <div>
                <a href="${permalink}" class="button__reset button__outline-diamond--opaque">view showroom details</a>
                <a href="" class="mb-3 button__reset button__outline-diamond--opaque nearest-showroom-book-btn" data-branch="${slug}">book a design appointment</a>
              </div>
            </div>
          </div>`;
          return el;
      }
      function sortByDistDM(a, b) { return (a.distance.value - b.distance.value); }

    }//END is postcode-form




    //==========================================
    //  When picking an item from the booking
    //  form branch selector - render branch
    //  info to the side
    //  Added: 26/7/22
    //==========================================
    if(document.getElementById('booking-form')){
      if(document.getElementById('book-design-appointment-form') && showrooms){
        const branchSelect = document.querySelector('#book-design-appointment-form .gform_body .gform_fields .gfield .ginput_container_select > select');
        if(branchSelect.value){ handleDisplayBranchInfo(branchSelect.value); }                // ON LOAD
        branchSelect.addEventListener('change', (e)=>{                                        // ON CHANGE
          let selectedBranch = e.target.value;
          if(selectedBranch){
            handleDisplayBranchInfo(selectedBranch);
          } 
        });
      }
    }


    //==========================================
    //  Grab branch info and swap data around
    //  of select menu change
    //  Added: 26/7/22
    //==========================================
    function handleDisplayBranchInfo(branch = null){
      const branchInfo = document.getElementById('current-branch-info');
      if(branch){
        let rez = showrooms.find( ({slug}) => slug === branch );
        if(branchInfo && rez){
          branchInfo.classList.remove('d-none');
          let title = document.querySelector('#current-branch__title');
          let address = document.querySelector('#current-branch__address');
          let hours =  document.querySelector('#current-branch__hours');
          let link =  document.querySelector('#current-branch__link');
          let now = new Date();
          let today = now.getUTCDay();

          // Account for Monday being in position 0 rather than Sunday (ACF dates are off)
          today = today -1;
          today = ( (today) < 0 ) ? 6 : today; 

          if(rez['opening_hours'][today]['appointment_only']){ hours.innerText = 'Appointment Only Today'; }
          else if(rez['opening_hours'][today]['showroom_closed']){ hours.innerText = 'Showroom Closed Today'; }
          else if(rez['opening_hours'][today]['opening_time'] && rez['opening_hours'][today]['closing_time']){
            hours.innerText = `Open today: ${rez['opening_hours'][today]['opening_time'].replace(' ', '')} - ${rez['opening_hours'][today]['closing_time'].replace(' ', '')}`;
          }
          else{ hours.innerText = 'Check showroom details for opening times'; }
          title.innerText = rez['branch'];
          address.innerText = rez['address'];
          link.href = rez['permalink'];
        }else{
          branchInfo.classList.add('d-none');
        }
      }else{
        branchInfo.classList.add('d-none');
      }
    }

    //Add class to 5th blog post element for different styling
    // $('body.blog .container .row.gx-5 .blog-post__item:nth-child(5n)').addClass('blog-post__item--full');
    // $('body.blog .container .row.gx-5 .blog-post__item:nth-child(5n)').removeClass('col-md-6');
    // $('body.blog .container .row.gx-5 .blog-post__item--full').removeClass('blog-post__item');

    //Show back to top after scroll
    $(document).on('scroll', function() {
      var y = $(this).scrollTop();
      if (y > 200) {
        $('.back-to-top').fadeIn();
      } else {
        $('.back-to-top').fadeOut();
      }
    });

    //Back to top on click
    $('.back-to-top').on('click', function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });

    document.querySelectorAll('.showroom-card__book-btn').forEach(item => {
      item.addEventListener('click', (e) => {
        handleDisplayBranchInfo(e.target.attributes.branch.value);
        selectBranchFromForm(e.target.attributes.branch.value);
      });
    });


    function selectBranchFromForm(branch = null){
      if(!branch){ return false; }
      let form = document.querySelector('.booking-appointment__form form');
      let bookingForm = document.querySelector('#book-design-appointment-form .gform_body .gform_fields .gfield .ginput_container_select > select');

      if(bookingForm && branch){

        for(let i = 0; i<bookingForm.options.length; i++){
          if(bookingForm.options[i].value == branch){
            bookingForm.options[0].selected = false;
            bookingForm.options[0].removeAttribute('selected')
            bookingForm.options[i].selected = true;
          }
        }

        // var event = new Event('change');// Create a new 'change' event
        bookingForm.dispatchEvent(new window.Event('change', { bubbles: true }));// Dispatch it.
 
        window.scrollTo({
          top: form.getBoundingClientRect().top + window.scrollY - 120,
          behavior: 'smooth',
        })
      }
    }

    // Prefill form from book a design appointment form on single branches pages
    window.addEventListener('load', () => {
      const bookingForm =  document.querySelector('.booking-appointment');
      if(bookingForm){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const branchSlug = urlParams.get('branch');
        selectBranchFromForm(branchSlug);
      }
    })






    //Append book a design appt button at bottom of sub-menus on mobile nav
    $('.mobile-nav__sub-menu .container ul').append('<li class="book-button--mobile"><a class="d-inline" href="/book-a-design-appointment">book a design appointment</a></li>');

    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
      if(formId === 3){
        let confirmation = document.querySelector('.gform_confirmation_message');
        let links = confirmation.querySelectorAll('a');
        if(links){
          links.forEach(link => {
            const elem = window.document.createElement('a');
            elem.href = link;
            elem.download = 'brochure';
            elem.target = '_blank';
            document.body.appendChild(elem);
            elem.click();        
            document.body.removeChild(elem);
          })
        }
      } 
    });

    //Stop the video playing when modal is closed on full width media block
    let modals = document.getElementsByClassName('modal');
    if(modals.length > 0) {
      for(let i=0; i<modals.length; i++) {
        modals[i].addEventListener('hide.bs.modal', function() {
          //find local video in modal
          let video = document.getElementsByClassName('file-video');
          //if found video
          if(video.length > 0) {
            //stop video
            video[0].pause();
          }

          //find embed video
          let embed = document.getElementsByTagName('iframe');
          //if found embed
          if(embed.length > 0) {
            //reset the iframe src
            embed[0].setAttribute('src', embed[0].getAttribute('src'));
          }
        });
      }
    }

    //Mini Gallery JS

    //Fullscreen Image Modal on Button Click
    let modalImage = document.querySelector('#fullScreenMiniGallery img');

    //For 3 images
    if($('.tkd-mini-gallery__static__image__wrapper img')) {
      $('.tkd-mini-gallery__static__image__wrapper img').on('click', function(event) {
        let selectedImage = $(event.target).attr('src');
        let selectedAlt = $(event.target).attr('alt');
        modalImage.src = selectedImage;
        modalImage.alt = selectedAlt;
      });
    }

    //For carousel
    if($('.tkd-mini-gallery__carousel__image__wrapper img')) {
      $('.tkd-mini-gallery__carousel__image__wrapper img').on('click', function(event) {
        let selectedImage = $(event.target).attr('src');
        let selectedAlt = $(event.target).attr('alt');
        modalImage.src = selectedImage;
        modalImage.alt = selectedAlt;
      });
  }

  if($('.tkd-mini-gallery__carousel')) {
    $('.tkd-mini-gallery__carousel').each(function() {
      $(this).slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 750,
        autoplay: false,
        // prevArrow: $('.tkd-mini-gallery__arrows--prev'),
        // nextArrow: $('.tkd-mini-gallery__arrows--next'),
        prevArrow: $(this).parent().siblings().find('.tkd-mini-gallery__arrows--prev'),
        nextArrow: $(this).parent().siblings().find('.tkd-mini-gallery__arrows--next'),
        swipe: true,
        swipeToSlide: true,
        draggable: true,
        cssEase: 'ease-in-out',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            },
          },
      ],
      });
    });
  }

  },


  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    //add script after page is loaded - this will use the code in the init() object as a callback
    if(document.getElementById('postcode-form')){
      var el = document.createElement('script');
      el.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBpMNVqH69ckOFYSnqUovDA2pZqyXZhb1w&libraries=places,geometry&callback=initMap&v=weekly';
      el.setAttribute('defer', true);
      el.setAttribute('async', true);
      var body = document.getElementsByTagName('body')[0];
      body.append(el);

      document.querySelector('#postcode-form > input').disabled = false;
      document.querySelector('#postcode-form > button').disabled = false;
    }

  },
};
